import { enums } from "@shared/constants";
import { PublicInternalAnalyticsTrackingSerializer } from "@shared/modules/analytics/types";
import {
  InitiateCheckoutDataBuilder,
  InitiateCheckoutDataBuilderData,
} from "./InitiateCheckoutDataBuilder";

export class RefundProtectionSelectionDataBuilder extends InitiateCheckoutDataBuilder {
  constructor(data?: InitiateCheckoutDataBuilderData) {
    super(data, enums.INTERACTION_LABEL_MAP.REFUND_PROTECTION_SELECTION.id);
  }

  build(): PublicInternalAnalyticsTrackingSerializer | null {
    return super.build();
  }
}
